import { handleError } from "../common/ErrorUtil";

import { executeGraphql, executeGraphqlLoop } from "./BaseApi";
import { updateOfficeInfo } from "./graphql/mutations";
import { listOfficeInfos } from "./graphql/queries";

/**
 * IoT-Box一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListMachineInfos() {
  const params = {
    nextToken: null,
  };
  const key = "listOfficeInfos";
  const { data, error } = await executeGraphqlLoop(
    listOfficeInfos,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      machineInfos: data[key].items,
    };
  } else {
    response.data = {
      machineInfos: [],
    };
  }

  return response;
}

/**
 * IoT-Box更新APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeUpdateOfficeInfo(payload) {
  const params = {
    input: {
      serialNumber: payload.serialNumber,
      remoteAccess: payload.remoteAccess,
      clientIp: payload.clientIp,
      enableTime: payload.enableTime,
    },
  };
  const { data, error } = await executeGraphql(updateOfficeInfo, params).catch(
    handleError
  );

  const key = "updateOfficeInfo";
  const response = { error };
  if (data && data[key]) {
    response.data = {
      uploadInfo: data[key],
    };
  } else {
    response.data = {
      uploadInfo: {},
    };
  }

  return response;
}
